// extracted by mini-css-extract-plugin
export default {"avatar-group":"fNsPd","avatar-group_size_l":"a0qHb","avatar-group_size_m":"u4hjc","avatar-group_size_s":"uWZ3W","avatar-group_wrap":"fiG5I","avatar-group__item":"dMui7"};